export class CampoAdicional{
    public constructor(
        public id: String = "",
        public codigo: String = "",
        public descripcion: String = "",
        public empresa_id: String = "",
        public usuario_id: String = "",
        public status: String = "",
    ){
        //
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/campo-adicional.ts